var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('TopToolbar'),_c('v-container',{staticClass:"overflow-y-auto",staticStyle:{"margin":"auto"}},[_c('p',[_vm._v("Noch nicht verfügbar")])]),_c('BottomNav',{attrs:{"active-item":'lockers'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }